type UrlValidationResult =
  | { isValid: true; url: string }
  | { isValid: false; error: "missing" | "malformed" | "unsafeScheme" }

const validateUrl = (encodedUri: string | null): UrlValidationResult => {
  if (!encodedUri) {
    return { isValid: false, error: "missing" }
  }

  let decodedUri: string
  try {
    decodedUri = decodeURIComponent(encodedUri)
  } catch {
    return { isValid: false, error: "malformed" }
  }

  let parsedUrl: URL
  try {
    parsedUrl = new URL(decodedUri)
  } catch {
    return { isValid: false, error: "malformed" }
  }

  if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
    return { isValid: false, error: "unsafeScheme" }
  }

  return { isValid: true, url: decodedUri }
}

export { validateUrl }
export type { UrlValidationResult }
